import classNames from 'classnames';
import React from 'react';

type Props = {
  id: string,
  downloadUrl: string,
  fileName?: string,
  type?: string,
  icon?: string,
  className?: string,
  tooltip?: string,
  children: React.ReactNode,
  openNewTab?: boolean
};

class DownloadButton extends React.Component<Props> {
  override render (): React.ReactNode {
    const { id, downloadUrl, icon, fileName, type,
      className, tooltip, children } = this.props;

    const openNewTab: boolean = (this.props.openNewTab !== false);

    let buttonType = 'esko_btn-default';
    if (type != null) {
      buttonType = type.split(' ').map(className => 'esko_' + className).join(' ');
    }

    const buttonClassName: string = classNames('esko_btn', buttonType, className);
    const downloadValue: string | true = (fileName !== undefined) ? fileName : true;

    if (icon != null) {
      return (
        <a id={id} className={buttonClassName}
          href={downloadUrl}
          download={downloadValue}
          title={tooltip}
          target={openNewTab ? '_blank' : undefined}>
          <span className={icon} style={React.Children.count(children) ? {marginRight: '5px'} : {}} />{children}
        </a>
      );
    } else {
      return (
        <a id={id} className={buttonClassName}
          href={downloadUrl}
          download={downloadValue}
          title={tooltip}
          target={openNewTab ? '_blank' : undefined}>
          {children}
        </a>
      );
    }
  }
}

export default DownloadButton;
